define(["require", "exports", "jquery", "./context"], function (require, exports, $, context_1) {
    "use strict";
    exports.__esModule = true;
    function displayAjaxLoading(display) {
        if (display) {
            $('.ajax-loading-block-window').show();
        }
        else {
            $('.ajax-loading-block-window').hide('slow');
        }
    }
    exports.displayAjaxLoading = displayAjaxLoading;
    function displayPopupNotification(message, messagetype, modal, timeInterval) {
        var container = null;
        if (messagetype == 'success') {
            container = $('#dialog-notifications-success');
        }
        else if (messagetype == 'error') {
            container = $('#dialog-notifications-error');
        }
        else {
            container = $('#dialog-notifications-success');
        }
        var htmlcode = '';
        if ((typeof message) == 'string') {
            htmlcode = '<p>' + message + '</p>';
        }
        else {
            for (var i = 0; i < message.length; i++) {
                htmlcode = htmlcode + '<p>' + message[i] + '</p>';
            }
        }
        container.html(htmlcode);
        var isModal = (modal ? true : false);
        container.dialog({
            modal: isModal,
            resizable: !context_1["default"].isMobile(),
            draggable: !context_1["default"].isMobile()
        });
        if (timeInterval) {
            setTimeout(function () { container.dialog('close'); }, timeInterval);
        }
    }
    exports.displayPopupNotification = displayPopupNotification;
    var barNotificationTimeout = undefined;
    function displayBarNotification(message, messagetype, timeout) {
        if ($.isNumeric(barNotificationTimeout)) {
            clearTimeout(barNotificationTimeout);
        }
        var cssclass = 'success';
        if (messagetype == 'success') {
            cssclass = 'success';
        }
        else if (messagetype == 'error') {
            cssclass = 'error';
        }
        $('#bar-notification')
            .removeClass('success')
            .removeClass('error');
        $('#bar-notification .content').remove();
        var htmlcode = '';
        if ((typeof message) == 'string') {
            htmlcode = '<p class="content">' + message + '</p>';
        }
        else {
            for (var i = 0; i < message.length; i++) {
                htmlcode = htmlcode + '<p class="content">' + message[i] + '</p>';
            }
        }
        $('#bar-notification').append(htmlcode)
            .addClass(cssclass)
            .fadeIn('slow')
            .mouseenter(function () {
            clearTimeout(barNotificationTimeout);
        });
        $('#bar-notification .close').unbind('click').click(function () {
            $('#bar-notification').fadeOut('slow');
        });
        if (timeout > 0) {
            barNotificationTimeout = setTimeout(function () {
                $('#bar-notification').fadeOut('slow');
            }, timeout);
        }
    }
    exports.displayBarNotification = displayBarNotification;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/notifications.js
// module id = 29
// module chunks = 0